/** O termo tem duas folhas: identificação e análise; níveis, ocorrências e conclusão. */
export const TOTAL_DE_FOLHAS = 2

/**
 * O rodapé, escrito em cada folha.
 *
 * Escrito por folha, e não fixado na janela, pela mesma razão do RDM: navegador não repete elemento
 * `position: fixed` em toda página impressa de forma confiável, e o resultado seria um rodapé só na
 * primeira. Como as quebras de página são nossas, sabemos em que folha estamos.
 *
 * **O código do documento carrega a versão do fechamento.** Reabrir e fechar de novo gera a versão
 * seguinte, e o código muda junto — é o que permite dizer se a folha que está no processo é a mesma
 * que está na tela, ou uma emissão anterior à reabertura.
 *
 * @param props código do documento, instante da emissão e o número da folha
 * @returns o rodapé de uma folha
 */
export function RodapeDoTrp({ codigo, emitidoEm, pagina }: { codigo: string; emitidoEm: string; pagina: number }) {
  return (
    <footer className="trp-rodape">
      <span>
        Código do Documento: {codigo} — Emitido em {emitidoEm}
      </span>
      <span style={{ whiteSpace: 'nowrap' }}>
        Página {pagina} de {TOTAL_DE_FOLHAS}
      </span>
    </footer>
  )
}
